// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__GeutU","notes":"Notes_notes__3A2Ps"};